import { createUseStyles } from 'react-jss'
import { colors, zIndexes } from '../../variables.style'

const headerMargin = 11
const textWidth = 600
const chartWidth = 1024
const sectionPadding = '10px 0'

export const style = {
  pageLayoutWrapper: {
    margin: '0 auto',
    minWidth: chartWidth
  },
  viewCommentsLabel: {
    alignSelf: 'center',
    marginRight: 5
  },
  contentHeader: {
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 3,
    padding: sectionPadding,
    marginBottom: 10
  },
  lastUpdate: {
    fontSize: 11,
    '&::before': {
      top: 2,
      position: 'relative'
    },
    marginBottom: headerMargin
  },
  title: {
    composes: 'h1 report-full-width',
    '&.h1': { marginBottom: 0 },
    paddingTop: 4,
    paddingBottom: 4
  },
  description: {
    fontSize: 16,
    maxWidth: 840,
    margin: '0 auto',
    paddingTop: 4,
    paddingBottom: 4,
    letterSpacing: 1,
    textTransform: 'none',
    whiteSpace: 'pre-line'
  },
  metadata: {
    marginTop: 12,
    '& a': {
      color: colors.oriolesOrange
    }
  },
  summary: {
    maxWidth: textWidth,
    textAlign: 'justify',
    padding: sectionPadding
  },
  caption: {
    maxWidth: chartWidth,
    fontSize: 14,
    textAlign: 'justify',
    borderTop: `1px solid ${colors.borderGray}`,
    color: colors.textGray,
    padding: sectionPadding
  },
  text: {
    maxWidth: textWidth
  },
  blockHighlight: {
    boxShadow: `0px 0 8px 0px ${colors.metallicSeaweed}`,
    '& .block-section-icon': {
      display: 'none'
    }
  },
  pageNavigator: {
    composes: 'flex-row report-full-width',
    marginTop: 100,
    borderTop: `1px solid ${colors.gray}`
  },
  prevPageContainer: {
    composes: 'flex-auto flex-row',
    alignItems: 'center',
    height: 100,
    width: 350,
    textDecoration: 'none',
    color: colors.gray,

    '&:hover': {
      color: colors.oriolesOrange
    }
  },
  nextPageContainer: {
    extend: 'prevPageContainer',
    textAlign: 'right'
  },
  prevPageChevron: {
    composes: 'font-icon-chevron-left',
    padding: '10px 20px 0 0',
    fontSize: 30
  },
  nextPageChevron: {
    composes: 'font-icon-chevron-right',
    padding: '10px 0 0 20px',
    fontSize: 30
  },
  pageNavLabel: {
    textTransform: 'uppercase',
    fontSize: 16,
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical'
  },
  pageNavDesc: {
    extend: 'pageNavLabel',
    marginTop: 12,
    fontSize: 12
  },
  pageControlBarContainer: {
    position: 'fixed',
    top: 0,
    margin: '0 auto',
    zIndex: zIndexes.pageControlBar
  }
}

export const useStyles = createUseStyles(style)
